import styled, { css } from 'styled-components'
import Filter from '../../../../assets/icons/filter.svg'

export const Container = styled.div`
    max-width: 6rem;
`

export const FilterIcon = styled(Filter)`
    width: 1rem;
    height: 1rem;
`

export const ChipWrapper = styled.div(
    ({ theme }) => css`
        position: relative;

        > div:first-child {
            height: 2.15rem;
            padding: 0.5rem ${theme.spacing.xSmall};
            gap: ${theme.spacing.xxSmall};
            border-radius: 8rem;
        }
    `,
)

export const FilterBadge = styled.div(
    ({ theme }) => css`
        height: 1.5rem;
        width: 1.5rem;
        background-color: #282828;
        color: white;
        flex-shrink: 0;
        display: grid;
        place-items: center;
        position: absolute;
        top: -0.65rem;
        right: -0.65rem;
        font-size: ${theme.typography.font.size.xSmall};
        line-height: 1;
        border-radius: 50%;
        border: 1.5px solid white;
        z-index: 1;
        box-sizing: border-box;
        padding: 0;
        overflow: hidden;
        text-indent: -0.5px;
    `,
)
